var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeWidth: "1pt"
}, /*#__PURE__*/React.createElement("path", {
  fill: "gold",
  d: "M0 0h640v480H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0057b8",
  d: "M0 0h640v240H0z"
}))));
export { SvgUa as ReactComponent };
export default __webpack_public_path__ + "assets/images/ua.423c68f9fb154fb2749b64a16d0968e1.svg";